<template>
  <div>
    <Button type="info" shape="circle" icon="md-add" style="margin:.5rem 2rem" @click="NewBuildHandleClick">新增</Button>
    <Table  ref="selection" :columns="columns12" :data="FreightList" max-height="600">
        <template slot-scope="{ row, index }" slot="action">
            <a href="#" @click.prevent="EditHandleClick(index)">
              编辑
            </a>
            <Divider type="vertical"/>
            <Button type="error"  size="small" @click="DeleteHandleClick(index)">删除</Button>
        </template>
    </Table>
  </div>
</template>

<script>
export default {
  name: 'FreightTable',
  props: {
    FreightList: Array
  },
  data () {
    return {
      columns12: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '国家',
          key: 'Country'
        },
        {
          title: '省份',
          key: 'Province'
        },
        {
          title: '城市',
          key: 'City'
        },
        {
          title: '地区',
          key: 'Region'
        },
        {
          title: '乡镇',
          key: 'Township'
        },
        {
          title: '物流点自提价格',
          key: 'SelfMention'
        },
        {
          title: '物流送货上门价格',
          key: 'Delivery'
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    // 点击新增按钮回调
    NewBuildHandleClick () {
      this.$emit('NewBuildHandleClick')
    },
    // 点击编辑按钮回调
    EditHandleClick (index) {
      this.$emit('EditHandleClick', index)
    },
    // 点击删除按钮回调
    DeleteHandleClick (index) {
      this.$emit('DeleteHandleClick', index)
    }
  }
}
</script>
